import { useT } from "@/lib/i18n";
import { useInView } from "framer-motion";
import React, { useEffect, useRef, useState } from "react";

// 25 家合作伙伴品牌高清 Logo 列表
const PARTNER_LOGOS = [
  { name: "珀莱雅", url: "https://photog-test.oss-accelerate.aliyuncs.com/uploads/public/report/20260827/5d2a9cecd45f43baa04be102b2f0705a.png" },
  { name: "宝洁", url: "https://photog-test.oss-accelerate.aliyuncs.com/uploads/public/report/20260827/d1cfd410ef254914bf5830fbc0223469.png" },
  { name: "Plug and Play China", url: "https://photog-test.oss-accelerate.aliyuncs.com/uploads/public/report/20260827/30e661d1d48543d8a5ffedcd8d2db003.png" },
  { name: "传音", url: "https://photog-test.oss-accelerate.aliyuncs.com/uploads/public/report/20260827/50eb617ce32749d9bd10dd2c5c579dc8.png" },
  { name: "开云基金会", url: "https://photog-test.oss-accelerate.aliyuncs.com/uploads/public/report/20260827/b6de3989bc76422c8b12e78f13303ea1.png" },
  { name: "懂车帝", url: "https://photog-test.oss-accelerate.aliyuncs.com/uploads/public/report/20260827/12b8a44988de4903972c78d740909099.png" },
  { name: "卡姿兰", url: "https://photog-test.oss-accelerate.aliyuncs.com/uploads/public/report/20260827/8cd086017ef74029bcd74827c220fd02.png" },
  { name: "乐播投屏", url: "https://photog-test.oss-accelerate.aliyuncs.com/uploads/public/report/20260827/279df0b04d9c40df97ddc5ff2f841437.png" },
  { name: "时空壶", url: "https://photog-test.oss-accelerate.aliyuncs.com/uploads/public/report/20260827/652c8689f0c2438f82fc8a81b348c965.png" },
  { name: "行云集团", url: "https://photog-test.oss-accelerate.aliyuncs.com/uploads/public/report/20260827/677c1c573e314e01bc9fe5b3abcff19e.png" },
  { name: "铂陆帝", url: "https://photog-test.oss-accelerate.aliyuncs.com/uploads/public/report/20260827/b863370c9e844963a72d82ce2e6ffe32.png" },
  { name: "万魔", url: "https://photog-test.oss-accelerate.aliyuncs.com/uploads/public/report/20260827/81d63938e0534111aef3933d5ce8245e.png" },
  { name: "李锦记", url: "https://photog-test.oss-accelerate.aliyuncs.com/uploads/public/report/20260827/650d3fee1eb04c8888565f9c4c509e51.png" },
  { name: "FunnyFuzzy", url: "https://photog-test.oss-accelerate.aliyuncs.com/uploads/public/report/20260827/5f0c48dd7b514589b665b23354f8f69e.png" },
  { name: "Filippo Loreti", url: "https://photog-test.oss-accelerate.aliyuncs.com/uploads/public/report/20260827/6cb67cd6a8904ec188702edde2dfb890.png" },
  { name: "左点健康", url: "https://photog-test.oss-accelerate.aliyuncs.com/uploads/public/report/20260827/e71ca54e0f8c47baa8209a93a6e1e5e8.png" },
  { name: "TRAJECTRY", url: "https://photog-test.oss-accelerate.aliyuncs.com/uploads/public/report/20260827/54f58b4bf5ee4bc99a5c2b9d1d8d8dd6.png" },
  { name: "天下秀", url: "https://photog-test.oss-accelerate.aliyuncs.com/uploads/public/report/20260827/5fb50034287942e88db91d7dafe611ed.png" },
  { name: "reenda", url: "https://photog-test.oss-accelerate.aliyuncs.com/uploads/public/report/20260827/806dbca768bb41bba7f5de6b1fe74820.png" },
  { name: "创界通", url: "https://photog-test.oss-accelerate.aliyuncs.com/uploads/public/report/20260827/02d8d1142b164b85818e3b71b44a641c.png" },
  { name: "WaytoAGI", url: "https://photog-test.oss-accelerate.aliyuncs.com/uploads/public/report/20260827/51720535a5d24660aea4b57ad2b6fd2b.png" },
  { name: "红意文化", url: "https://photog-test.oss-accelerate.aliyuncs.com/uploads/public/report/20260827/c4195625cf5b494da093a29106e19af0.png" },
  { name: "雅诗兰黛", url: "https://photog-test.oss-accelerate.aliyuncs.com/uploads/public/report/20260827/cfd9fbac1c8a42f285adec016b0f9ede.png" },
  { name: "矩阵纵横", url: "https://photog-test.oss-accelerate.aliyuncs.com/uploads/public/report/20260827/82c23da4489a44fb9721234b3de7702d.png" },
  { name: "长安汽车", url: "https://photog-test.oss-accelerate.aliyuncs.com/uploads/public/report/20260827/07e75829c6e945899c25781aa0648490.png" },
];

interface MetricItemProps {
  target: number;
  suffix?: string;
  label?: string;
  line1?: string;
  line2?: string;
}

const MetricItem: React.FC<MetricItemProps> = ({ target, suffix = "", label, line1, line2 }) => {
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, { once: true, margin: "-40px" });
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!isInView) return;
    const duration = 1600; // 1.6s
    const startTime = performance.now();

    const update = (now: number) => {
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const ease = 1 - Math.pow(1 - progress, 3);
      const current = Math.floor(ease * target);
      setCount(current);

      if (progress < 1) {
        requestAnimationFrame(update);
      } else {
        setCount(target);
      }
    };

    requestAnimationFrame(update);
  }, [isInView, target]);

  const displayLabel = label || `${line1 || ""}${line2 || ""}`;

  return (
    <div
      ref={ref}
      className="flex items-baseline md:items-center justify-center gap-3 sm:gap-3.5 min-w-0"
    >
      {/* 渐变大数字 + 紧凑单位后缀 */}
      <span className="flex items-baseline font-bold tracking-tight tabular-nums whitespace-nowrap bg-gradient-to-b from-[#FDBA74] via-[#FDBA74] to-[#F97316] bg-clip-text text-transparent leading-none select-none">
        <span className="text-4xl sm:text-5xl lg:text-[54px] font-bold">
          {count}
        </span>
        {suffix && (
          <span className="text-xl sm:text-2xl lg:text-[28px] font-bold ml-1 tracking-normal">
            {suffix}
          </span>
        )}
      </span>

      {/* 结构化单行文字标签（精致克制黄金尺寸 13px~14.5px） */}
      <span className="text-[13px] sm:text-[14px] lg:text-[14.5px] font-medium leading-none text-[#F2ECE5]/80 tracking-normal text-left whitespace-nowrap shrink-0">
        {displayLabel}
      </span>
    </div>
  );
};

/**
 * S3b · 实时数据横幅 + 客户 Logo 跑马灯滚动
 * 100% 采用 Tailwind CSS 工具类与 i18n 多语言系统
 */
export const DataManifestBanner: React.FC = () => {
  const t = useT();

  return (
    <section
      className="relative w-full overflow-hidden border-y border-[#F97316]/30 bg-[#120E0A]"
      style={{
        background: `
          radial-gradient(900px 360px at 50% 0%, rgba(249, 115, 22, 0.14) 0%, transparent 75%),
          linear-gradient(180deg, rgba(249, 115, 22, 0.08) 0%, rgba(249, 115, 22, 0.02) 100%),
          #120E0A
        `,
      }}
      aria-label={t("Realtime Data & Partners", "实时数据与客户")}
    >
      {/* 顶部流光扫描线 */}
      <div
        className="pointer-events-none absolute top-0 h-[1.5px] w-[28%] bg-gradient-to-r from-transparent via-[#F97316] to-transparent animate-scan-x"
        aria-hidden="true"
      />

      {/* 4 大核心数据指标（自适应平衡分布，消除左疏右密） */}
      <div className="max-w-[1320px] mx-auto grid grid-cols-2 lg:grid-cols-[0.9fr_1fr_1.15fr_1.15fr] items-center justify-items-center gap-y-8 gap-x-6 sm:gap-x-8 lg:gap-x-10 px-6 sm:px-10 lg:px-12 py-8 sm:py-11">
        <MetricItem
          target={5}
          label={t("Platforms Covered", "覆盖平台")}
        />
        <MetricItem
          target={120}
          suffix={t("M", "万")}
          label={t("Content Published", "内容发布")}
        />
        <MetricItem
          target={4000}
          suffix="+"
          label={t("AI Creator Matrix", "AI达人矩阵账号")}
        />
        <MetricItem
          target={100}
          suffix={t("M", "万级")}
          label={t("Audience Simulated", "预演人群规模")}
        />
      </div>

      {/* 客户品牌 Logo 跑马灯滚动（Tailwind 纯类名构建） */}
      <div
        className="relative overflow-hidden border-t border-[#F97316]/20"
        aria-label={t("Partner Brand Logos", "客户品牌 Logo")}
      >
        {/* 两侧羽化遮罩 */}
        <div
          className="overflow-hidden"
          style={{
            maskImage: "linear-gradient(90deg, transparent, #000 10%, #000 90%, transparent)",
            WebkitMaskImage: "linear-gradient(90deg, transparent, #000 10%, #000 90%, transparent)",
          }}
        >
          <div className="flex w-max items-center py-4 sm:py-5 animate-marquee">
            {/* 拼接两份实现 40s 无缝平滑滚动 */}
            {[...PARTNER_LOGOS, ...PARTNER_LOGOS].map((partner, index) => (
              <div
                key={`${partner.name}-${index}`}
                className="flex items-center gap-3.5 px-7 sm:px-9 border-r border-[#F97316]/20 shrink-0"
              >
                <div className="inline-flex items-center justify-center w-[102px] h-9 shrink-0 opacity-80 hover:opacity-100 transition-opacity">
                  <img
                    src={partner.url}
                    alt={`${partner.name} Logo`}
                    className="max-w-[102px] max-h-9 w-full h-full object-contain object-center block"
                    loading="lazy"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default DataManifestBanner;
